import { runImpactCalculateCo2ForProject } from '@/domain/impact-calculate/actions/run-impact-calculate-co2-for-project.action';
import { SnackbarGateway } from '@/domain/snackbar/gateways/snackbar.gateway';
import { createAppAsyncThunk } from '@/domain/store.thunk';
import { translate } from '@/ui/i18n';

import { ImpactCo2Answer } from '../entities/question.entity';
import { getImpactCo2Answers } from './get-impact-co2-answers.action';

type Params = {
  projectId: number;
  answers: ImpactCo2Answer[];
  deleteExistingAnswers: boolean;
};

export const importImpactCo2Answers = createAppAsyncThunk(
  'impactCo2/importImpactCo2Answers',
  async (
    { projectId, answers, deleteExistingAnswers }: Params,
    { extra: { impactCo2Gateway, snackbarGateway }, dispatch },
  ) => {
    try {
      await impactCo2Gateway.importImpactAnswers(
        projectId,
        answers,
        deleteExistingAnswers,
      );
      showSnackbarSuccess(snackbarGateway);
      await dispatch(getImpactCo2Answers({ projectId }));
      await dispatch(runImpactCalculateCo2ForProject({ projectId }));
    } catch (error) {
      showSnackbarError(snackbarGateway);
      throw error;
    }
  },
);

function showSnackbarSuccess(snackbarGateway: SnackbarGateway) {
  snackbarGateway.success(translate('ImportImpactCo2Answers.Message.success'));
}

function showSnackbarError(snackbarGateway: SnackbarGateway) {
  snackbarGateway.error(translate('ImportImpactCo2Answers.Message.error'));
}
